import { DetailFormComponentsEnum } from "@/lib/enum/detail-form-components.enum";
import { TransmissionTypeEnum } from "@/lib/enum/transmission.enum";
import { Form, FormConfig, IsFormable } from "@/lib/formable";
import { MrfiktivUpdateVehicleRegistrationDtoGen } from "@/services/mrfiktiv/v1/data-contracts";
import { VehicleTypes } from "@/store/enum/vehicle-types.enum";
import { RegistrationBase } from "./registration.entity";

@IsFormable
export class UpdateVehicleRegistration extends RegistrationBase implements MrfiktivUpdateVehicleRegistrationDtoGen {
  @FormConfig({
    category: "common.nouns.configuration",
    searchKeywords: ["common.nouns.configuration", "objects.vehicle.registration.transmission"],
    type: DetailFormComponentsEnum.TEXT_FIELD,
    props: {
      required: false,
      label: "objects.vehicle.registration.transmission",
      rules: [],
      items: Object.values(TransmissionTypeEnum)
    }
  })
  transmission?: TransmissionTypeEnum | "";

  @FormConfig({
    category: "common.nouns.vehicleRegistration",
    searchKeywords: ["objects.vehicle.registration.model", "common.nouns.vehicleRegistration"],
    type: DetailFormComponentsEnum.TEXT_FIELD,
    props: {
      label: "objects.vehicle.registration.model"
    },
    clearable: true
  })
  model?: string = "";

  @FormConfig({
    category: "common.nouns.configuration",
    searchKeywords: ["common.nouns.configuration", "objects.vehicle.registration.vehicleClass"],
    type: DetailFormComponentsEnum.AUTO_COMPLETE,
    props: {
      required: false,
      label: "objects.vehicle.registration.vehicleClass",
      rules: [],
      items: Object.values(VehicleTypes)
    }
  })
  vehicleClass?: VehicleTypes;

  constructor(data?: MrfiktivUpdateVehicleRegistrationDtoGen) {
    super(data);
    this.transmission = data?.transmission as TransmissionTypeEnum;
    this.vehicleClass = data?.vehicleClass as VehicleTypes;
    this.model = data?.model ?? "";
  }
}

export const UpdateVehicleRegistrationDto = Form.createForClass(UpdateVehicleRegistration);
